export const isBackOfficeAppPath = (pathname: string = window.location.pathname) =>
  pathname.split('/')[2] === 'backoffice';
